import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=73034ca2&scoped=true&"
import script from "./BaseInputFile.vue?vue&type=script&lang=js&"
export * from "./BaseInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFile.vue?vue&type=style&index=0&id=73034ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73034ca2",
  null
  
)

export default component.exports